export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1722247520734-d17372bde1bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kitchen:
    "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bathroom:
    "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  living:
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  addition:
    "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  flooring:
    "https://images.pexels.com/photos/18285887/pexels-photo-18285887.jpeg",
  craft:
    "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  craftWide:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  {
    id: "kitchens",
    num: "01",
    title: "Kitchens",
    blurb: "Sculpted islands, honed stone, and cabinetry milled to the millimetre.",
    image: IMAGES.kitchen,
    span: "md:col-span-8",
    tall: true,
  },
  {
    id: "bathrooms",
    num: "02",
    title: "Bathrooms",
    blurb: "Sanctuaries in marble, brass and warm ambient light.",
    image: IMAGES.bathroom,
    span: "md:col-span-4",
    tall: true,
  },
  {
    id: "additions",
    num: "03",
    title: "Additions",
    blurb: "Second storeys and extensions that read as if they were always there.",
    image: IMAGES.addition,
    span: "md:col-span-4",
    tall: false,
  },
  {
    id: "living",
    num: "04",
    title: "Living Spaces",
    blurb: "Open-plan reworks with structural nerve and quiet materials.",
    image: IMAGES.living,
    span: "md:col-span-8",
    tall: false,
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Consultation",
    body: "We begin on site, listening. Every renovation starts with the way you actually live — light, movement, ritual.",
  },
  {
    num: "02",
    title: "Design & Drawings",
    body: "Measured drawings, material palettes and a fixed scope. No surprises, only decisions made with intent.",
  },
  {
    num: "03",
    title: "The Build",
    body: "One dedicated crew, one site manager, obsessive detailing. We treat your home as if it were our own.",
  },
  {
    num: "04",
    title: "Handover",
    body: "A final walk-through, a snag-free finish, and a home that outlasts trends by a generation.",
  },
];

export const STATS = [
  { value: "20", suffix: "yrs", label: "Building across the state" },
  { value: "480", suffix: "+", label: "Homes renovated" },
  { value: "98", suffix: "%", label: "On-time completion" },
  { value: "12", suffix: "wk", label: "Average build window" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Green Star took a dark, choppy 1970s bungalow and gave us light we didn't know the site had. The craft is in every joint.",
    name: "Elena & Marc Rossi",
    project: "Full-home renovation, Ashfield",
  },
  {
    quote:
      "They said twelve weeks and handed us the keys in eleven. The kitchen is the best room in the house now.",
    name: "Priya Nair",
    project: "Kitchen & living, Balmain",
  },
  {
    quote:
      "Impeccable communication. Our second-storey addition looks original — nobody believes it's new.",
    name: "James Whitlock",
    project: "Second-storey addition, Manly",
  },
];
